module.exports = __webpack_public_path__ + "static/media/booth-thumb.87652499.jpg";